import gsap from 'gsap';
import '../scss/_udl.scss';
import './scripts.js';
import './graphs.js';

window.gsap = gsap;
